import Box from '@mui/material/Box'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'

const NotificationsFooter = ({ onClick }) => {
  return (
    <Box
      sx={{
        pt: 1.5,
        borderTop: 1,
        borderColor: 'divider',
        textAlign: 'center',
      }}
    >
      <Link
        component="button"
        type="button"
        onClick={onClick}
        underline="always"
        sx={{
          color: '#2666BE',
          fontWeight: 500,
          fontSize: '0.875rem',
          textDecorationColor: 'transparent',
          '&:hover': {
            color: '#2666BE',
            textDecorationColor: '#2666BE',
          },
        }}
      >
        <Typography variant="body1" sx={{ fontWeight: 500 }}>
          View all notifications
        </Typography>
      </Link>
    </Box>
  )
}

export default NotificationsFooter